export const EMAIL_INTEGRATION_KEY = "email" as const;
